import { fetchPath } from '../../../utils/api'
import yodaFormatter from '../../../utils/api/yodaFormatter'
import actions from './actions'
import mutations from './mutations'
import state from './state'
import getters from './getters'

export default {
  namespaced: true,
  actions: actions({ fetchPath, yodaFormatter }),
  mutations,
  state,
  getters,
}
